import { render, staticRenderFns } from "./CardLegend.vue?vue&type=template&id=4d45fc47&"
import script from "./CardLegend.vue?vue&type=script&lang=js&"
export * from "./CardLegend.vue?vue&type=script&lang=js&"
import style0 from "./CardLegend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports